import { cn } from "../../lib/utils";
import { ArrowUpIcon, ArrowDownIcon } from "lucide-react";
import { Card, CardContent } from "./card";

interface StatCardProps {
  icon: React.ReactNode;
  label: string;
  value: string;
  change?: string;
  trend?: 'up' | 'down' | 'neutral';
  iconBg?: string;
  className?: string;
}

const StatCard = ({ 
  icon, 
  label,

  value, 
  change, 
  trend,
  iconBg, 
  className 
}: StatCardProps) => {
  
  return (
    <Card className={cn("h-full overflow-hidden", className)}>
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">{label}</p>
            <div className="flex items-baseline gap-2">
              <h2 className="text -2xl font-bold">{value}</h2>
              {change && trend && (
                <p className={cn(
                  "text-xs font-medium", 
                  trend === "up" ? "text-green-600" : 
                  trend === "down" ? "text-red-600" : 
                  "text-gray-600"
                )}>
                  <span className="inline-flex items-center">
                    {trend === "up" && <ArrowUpIcon className="mr-0.5 h-3 w-3" />}
                    {trend === "down" && <ArrowDownIcon className="mr-0.5 h-3 w-3" />}
                    {change}
                  </span>
                </p>
              )}
            </div>
          </div>
          
          <div className={cn(
            "flex h-12 w-12 shrink-0 items-center justify-center rounded-full",
            iconBg || "bg-primary/10"
          )}>
            {icon}
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default StatCard;
